import RiderOffers from "../../services/api/RiderOffers";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";
import qs from "qs";

function handleError(err) {
  console.log("error in rider offers actions:", err);
}

export const setRiderOffers = (payload) => {
  return {
    type: ActionTypes.SET_RIDER_OFFERS,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_RIDER_OFFERS,
    payload,
  };
};

export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_RIDER_OFFERS_ACTIVE_FILTERS,
    payload,
  };
};

export const getRiderOffers = (filters) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const response = await RiderOffers.getRiderOffers(filters);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setRiderOffers(response));
      if (Object.keys(filters).length > 0) {
        dispatch(setActiveFilters(filters));
      } else if (Object.keys(filters).length === 0) {
        dispatch(resetState({ state: "activeFilters" }));
      }
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.RETRIEVAL_SUCCESS,
        })
      );
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
